// extracted by mini-css-extract-plugin
export default {"root":"left-bar-content_root__Nuz50","placeHolderShimmer":"left-bar-content_placeHolderShimmer__9669t"};